<template>
  <AppWrapper>
    <router-view :key="$route.fullPath"/>
  </AppWrapper>
</template>

<script>
import {mapActions} from "vuex";
import API from "@/plugins/api";
import AppWrapper from "@/components/common/AppWrapper.vue";

export default {
  name: "App",

  components: {
    AppWrapper,
  },

  watch: {
    "$auth.isAuthenticated": async (val) => {
      if (val && this && this.$auth) {
        const token = await this.$auth.getTokenSilently();
        API.setHeaders("Authorization", `Bearer ${token}`);
      }
    },
  },

  created() {
    //- APP startup code

    return Promise.all([
      //- API, store
      this.$store.dispatch("init"),
    ])
      .then(
        //- Flag to say we're ready to go
        () => this.setInitialized()
      )
      .catch((error) => {
        console.log("Error in init: ", error);
      });
  },

  methods: {
    ...mapActions("app", ["setInitialized"]),
  },
};
</script>